/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { useState ,useEffect,useRef} from 'react'
import './App.css'
import { motion } from 'framer-motion'
import React from 'react'
import NavigationRoutes from './routes'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate,useLocation } from 'react-router-dom'
import GlobalContext from './components/Context/GloablContext';
import { Amplify } from 'aws-amplify';
import {awsConfig} from './config/aws-export';
import { CheckUserStatus } from './CommonMethods/CheckUserStatus';
import Toast from './components/Toast';
import {identityPoolId,viteRegion,userpoolId} from '../src/config/index'
import { userService } from './services/user.services'
import refreshIdToken from './CommonMethods/RefreshIdFunction'
import { LOGOUT_MESSAGES } from './CommonMethods/authSession'
import { stage } from './config/index'
import { AwsRum } from 'aws-rum-web';
import { websocketURL } from '../src/config/index'
import { handleEditMessageSent,handleTargetUserEditId } from './redux/systemConfigSlice'
import { logout } from './pages/auth/authSlice'
import { AdminOrCorporateSearchProvider } from './components/Context/adminCorporateSearch'
import { handleSidebarAnimation } from './redux/commonSlice'
import { resetDeviceTemplateSearch } from './redux/deviceTemplateSearchSlice'
import { resetDeviceSearch } from './redux/deviceSearchSlice'
import { resetProviderSearch } from './redux/providerSearchSlice'
import { resetObserverSearch } from './redux/observerSearchSlice'
import { resetPatientSearch } from './redux/patientSearchSlice'
import { resetOrganizationSearch } from './redux/organizationSearchSlice'
import { resetDeviceAlertSearch } from './redux/deviceAlertReportSearchSlice'
import { resetAccessLogSearch } from './redux/accessLogSearchSlice'
import { usersList } from './features/apiSlice'
import { resetDeviceAlertDashboardSearch } from './redux/deviceAlertDashboardSlice'
import { dataService } from './services/data.services'
import { fetchImageAsBlob, getPDFImage, storePDFImage } from './components/HelpGuideModal/indexdb'
import { syncSessionFromLocalStorage, getAuthItem, clearAuthSession, broadcastLogout, subscribeToAuthEvents, validateAndCleanAuthSession } from './CommonMethods/authSession'
import { clearStoredIPAddress } from './services/ipAddress.service'
import { logIn, setUserType } from './pages/auth/authSlice'
import { resetState } from './redux/systemConfigSlice'
// import { fetchFeatureFlags } from './CommonMethods/AppConfig'

if (stage?.includes('prod:')){
try {
  const config = {
    sessionSampleRate: 1 ,
    identityPoolId: "us-east-1:20bc7567-ff51-4959-b9fd-a9261a3e0500" ,
    endpoint: "https://dataplane.rum.us-east-1.amazonaws.com" ,
    telemetries: ["performance","errors","http"] ,
    allowCookies: true ,
    enableXRay: false ,
    signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
  };

  const APPLICATION_ID = 'af36f9ed-0797-4b40-adaf-3f69dd7f766a';
  const APPLICATION_VERSION = '1.0.0';
  const APPLICATION_REGION = 'us-east-1';

  const awsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );console.log("AWS Rum")
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}
}



Amplify.configure(awsConfig);

function App(props) {
    const dispatch=useDispatch()
    const navigate=useNavigate()
    const editingUserIdRef = useRef('');
    const location=useLocation()
    const resetPasswordNavigatedRef = useRef(false);
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [isInitializing, setIsInitializing] = useState(true)
    const isInitializingRef = useRef(false)
    const [UpdateCall, setUpdateCall] = useState(false)
    const [Toastmessage, setToastmessage] = useState('');
    const [initialRoutePath,setInitialRoutePath] = useState('')
    const [editSocket,setEditSocket] = useState(false)
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const [confirmationState, setConfirmationState] = useState(false)
    const [ToastWarnmessage, setToastWarnmessage] = useState('')
    const restrict = useSelector(state=>state?.systemConfigData?.restrict)
    const editingUserId = useSelector(state=>state?.systemConfigData?.editingUserId)
    const [isSideBar, setIsSideBar] = useState(restrict);
    const [isOpen,setIsOpen] = useState(true)
    const [userEditId,setUserEditId] = useState('')

    // fetchFeatureFlags()

    // search states
    const [isAdvancedSearchOpen,setIsAdvancedSearchOpen]=useState(false)

    // Check if JWT token is expired by inspecting the 'exp' claim
    const isTokenExpired = (token) => {
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload.exp * 1000 < Date.now();
        } catch {
            return true; // Treat unparseable token as expired
        }
    };

    const handleRefreshToken = async () => {
        const token = getAuthItem('IdToken');
        if (token && !isTokenExpired(token)) {
            refreshIdToken(dispatch, logout);
        }
    };

    const sendMessageToStartEditing = (data,isReconnect,ws) => {
        const startEditingAction = { action: 'startEditing', target: data===''?editingUserId:data,user:sessionStorage.getItem('email') };
        if(isReconnect!==undefined && isReconnect==='reconnect'){
            ws.send(JSON.stringify(startEditingAction))
            setUserEditId(data)
            dispatch(handleEditMessageSent(true))
        }else if (editSocket && (editSocket?.readyState === 0 || editSocket?.readyState === 1)) {
        
            editSocket.send(JSON.stringify(startEditingAction));
            setUserEditId(data)
            dispatch(handleEditMessageSent(true))
        }else if(editSocket?.readyState===3){
            console.error('WebSocket connection is not open');
            WebSocketConnection('start',data)
        }else {
            // editSocket is false/undefined — happens on cross-tab login or before ws.onopen fires.
            // Establish connection and send startEditing once open via the 'reconnect' branch.
            console.warn('WebSocket not initialized, establishing connection and retrying');
            WebSocketConnection('start',data)
        }
    };
    const sendMessageToStopEditing = (data) => {
        const stopEditingAction = { action: 'stopEditing', target: userEditId===''?((data===undefined||data==='')?editingUserId:data):userEditId };
        if((!editSocket||editSocket?.readyState!==1)&&window?.websocket?.readyState===1&&(stopEditingAction?.target!==''&&stopEditingAction?.target!==undefined)&&(userEditId!==''||userEditId!==undefined)){
            window?.websocket?.send(JSON.stringify(stopEditingAction))
            dispatch(handleEditMessageSent(false))
            dispatch(handleTargetUserEditId(''))
        }
        else if (editSocket && (editSocket?.readyState === 0 || editSocket?.readyState === 1)&&(userEditId!==''||userEditId!==undefined||data!==undefined)) {
            editSocket?.send(JSON.stringify(stopEditingAction));
            dispatch(handleEditMessageSent(false))
            dispatch(handleTargetUserEditId(''))
        }else if(editSocket?.readyState===3){
            console.error('WebSocket connection is not open');
            //WebSocketConnection('stop',userEditId===''?data:userEditId)
        }
    }
    const WebSocketConnection = (startOrStop,targetId) =>{
        dispatch(handleEditMessageSent(false))
        // Close the socket we are replacing: the backend counts every live
        // connection as an active session.
        const previousSocket = window.websocket;
        if (previousSocket) {
            // Detach handlers first, or close() re-enters via the reconnect below.
            previousSocket.onmessage = null;
            previousSocket.onclose = null;
            previousSocket.onerror = null;
            if (previousSocket.readyState === 0 || previousSocket.readyState === 1) {
                previousSocket.close();
            }
        }
        const ws = new WebSocket(`${websocketURL}?user=${encodeURIComponent(sessionStorage.getItem('email'))}`);
        window.websocket = ws
        ws.onopen = () => {
            setEditSocket(ws)
            if(startOrStop!==undefined&&startOrStop==='start'){
                sendMessageToStartEditing(targetId===''?editingUserId:targetId,'reconnect',ws )
                //addpersist logic here to get target userid nd send message
            }else if(startOrStop!==undefined&&startOrStop==='stop'){
                sendMessageToStopEditing(targetId===''?editingUserId:targetId)
            }
            // You can add further logic here, like informing the server about the edit screen access.
        };
        ws.onclose = () => {
            const editRoutes = ['/manage-admin-corporate/add-admin-corporate/:id','/manage-organizations/add-organization/:id','/manage-provider/add-provider/:id','/manage-device-templates/edit-device-template/:id','/manage-devices/edit-device/:id','/manage-organizations/manage-organization-users/edit-organization-user/:id','/manage-monitoring-condition-templates/add-template/:id','/manage-observer/edit-observer/:id','/manage-patients/edit-patients/:id','/manage-monitor-user/add-monitor-user/:id']
            const editedUserId = editingUserIdRef.current;
            if(sessionStorage.getItem('IdToken')){
                editedUserId!==''?WebSocketConnection('start',editedUserId):WebSocketConnection();
            }
        }
        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
            // Only reconnect if user is still logged in (token exists)
            // Without this check, logout triggers reconnect via onerror
            if (sessionStorage.getItem('IdToken')) {
                setTimeout(WebSocketConnection, 3000);
            }
        };
    }

    // Close the socket before the page unloads or is frozen into the back/forward
    // cache. A stranded connection reads as an active session and blocks the next
    // login. Reopen it if the page comes back from that cache.
    useEffect(() => {
        const closeSocketOnPageHide = () => {
            const ws = window.websocket;
            if (!ws) { return; }
            ws.onmessage = null;
            ws.onclose = null;
            ws.onerror = null;
            if (ws.readyState === 0 || ws.readyState === 1) {
                ws.close();
            }
        };
        const reopenSocketOnRestore = (event) => {
            if (event.persisted && sessionStorage.getItem('IdToken')) {
                WebSocketConnection();
            }
        };
        window.addEventListener('pagehide', closeSocketOnPageHide);
        window.addEventListener('pageshow', reopenSocketOnRestore);
        return () => {
            window.removeEventListener('pagehide', closeSocketOnPageHide);
            window.removeEventListener('pageshow', reopenSocketOnRestore);
        };
    }, []);

    // Single initialization function - handles all session setup
    const initializeSession = async () => {
        // Prevent multiple simultaneous initializations
        if (isInitializingRef.current) {
            return;
        }
        isInitializingRef.current = true;

        try {
            // 0. Validate and clean auth session (clears corrupted/invalid tokens early)
            validateAndCleanAuthSession();

            // 1. Sync session from localStorage to sessionStorage (once)
            syncSessionFromLocalStorage();

            // 2. Check for token
            const idToken = getAuthItem('IdToken');
            if (!idToken) {
                // No token - ensure loggedIn is false
                dispatch(logout());
                setIsInitializing(false);
                return;
            }

            // 3. Validate token via API before setting loggedIn state
            try {
                const user = await dataService.GetAPI('users/check-status');
                const userType = user?.data?.data?.user_type;
                
                // Token is valid - set loggedIn state and user info
                if (userType) {
                    dispatch(setUserType(userType));
                }
                dispatch(logIn(getAuthItem('email') || ''));
                
                // Invalidate RTK Query cache to trigger refetch of all queries
                dispatch(usersList.util.resetApiState());
                dispatch(usersList.util.invalidateTags(['User', 'History']));

                // Setup token refresh and WebSocket if token exists
                refreshIdToken(dispatch, logout);
                WebSocketConnection();
            } catch (error) {
                // Treat any failure of check-status as an invalid session.
                // This avoids leaving the app in a "logged in but no data / 401" state
                // when the backend rejects or cannot validate the token.
                clearAuthSession();
                dispatch(resetState());

                // Set custom-status for SignIn.jsx to show appropriate toast on mount
                // Only for auth failures (401/403), not network/server errors
                const status = error?.response?.status;
                if (status === 401 || status === 403) {
                    localStorage.setItem('custom-status', 'inactive');
                }

                dispatch(logout());
            }
        } catch (error) {
            // Unexpected error during initialization
            console.error('Session initialization error:', error);
            dispatch(logout());
        } finally {
            setIsInitializing(false);
            isInitializingRef.current = false;
        }
    };

    // Initialize session on mount (once)
    useEffect(() => {
        initializeSession();

        // Setup token refresh interval (only refresh if token exists and is not expired)
        const intervalId = setInterval(() => {
            const token = getAuthItem('IdToken');
            if (token && !isTokenExpired(token)) {
                refreshIdToken(dispatch, logout);
            }
        }, 9 * 60 * 1000);
        
        return () => {
            clearInterval(intervalId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Handle reset-password navigation after initialization
    useEffect(() => {
        if (isInitializing) return; // Wait for initialization to complete

        const isFirstTimeLogin = getAuthItem('custom:is_first_time_login') === "true";
        if (isFirstTimeLogin && location.pathname !== '/reset-password' && !resetPasswordNavigatedRef.current) {
            resetPasswordNavigatedRef.current = true;
            navigate('/reset-password', { replace: true });
        } else if (!isFirstTimeLogin && location.pathname === '/reset-password') {
            // Flag cleared but still on reset-password page - redirect to login
            navigate('/', { replace: true });
        }
    }, [isInitializing, location.pathname, navigate]);


    useEffect(()=>{
        editingUserIdRef.current = editingUserId;
    },[editingUserId])


    const handleClear=()=>{
        if((Toastmessage&&Toastmessage!=='')||(toastErrorMessage&&toastErrorMessage!=='')){
            setToastmessage('');
            setToastErrorMessage();
        }
    }


    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {

            editSocket.onmessage = async (event) => {
                if (hasLoggedOut)
                    return; // Prevent multiple logout calls

                const message = event.data;

                if (message === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    // await userService.logout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    clearAuthSession();
                    broadcastLogout('duplicate');
                    clearStoredIPAddress();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    // Use sessionStorage so this flag survives reload but doesn't leak to other tabs
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    // Listen for logout events from other tabs
    useEffect(() => {
        const unsubscribe = subscribeToAuthEvents((eventType) => {
            if (eventType === 'logout') {
                // Close WebSocket connection and clean up edit locks
                if (editSocket && (editSocket.readyState === 0 || editSocket.readyState === 1)) {
                    // Send stopEditing to backend to clean up the edit lock before closing
                    if (editSocket.readyState === 1 && editingUserIdRef.current) {
                        try {
                            editSocket.send(JSON.stringify({
                                action: 'stopEditing',
                                target: editingUserIdRef.current
                            }));
                        } catch (error) {
                            console.error('Error sending stopEditing message:', error);
                        }
                    }
                    editSocket.close();
                }

                // User logged out in another tab
                const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
                const LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs');

                // Read logout reason BEFORE clearing auth (clearAuthSession removes it)
                const logoutReason = localStorage.getItem('arcm_logout_reason') || 'manual';

                // Clear auth session
                clearAuthSession();
                clearStoredIPAddress();


                // Preserve non-auth keys
                if (browserIdValue) {
                    localStorage.setItem('arcm_trust_browser_token', browserIdValue);
                }
                if (LogoutfromAllTabs) {
                    localStorage.setItem('LogoutfromAllTabs', LogoutfromAllTabs);
                }


                // Update Redux state
                dispatch(logout());
                dispatch(handleSidebarAnimation(true));

                // Show contextual toast message based on logout reason
                const toastMessage = LOGOUT_MESSAGES[logoutReason] || LOGOUT_MESSAGES.manual;
                setToastErrorMessage(toastMessage);
                navigate('/');
            }
        });

        return () => {
            unsubscribe();
        };
    }, [dispatch, navigate, setToastErrorMessage]);

    const fetchAndCacheHelpGuides = async () => {
        try {
            const apiResponse = await dataService.GetAPI('users/help-guides?getAllFiles=true'); 
            const files = apiResponse?.data?.data?.files || {}; 
    
            for (const [fileName, fileUrl] of Object.entries(files)) {
                const pageKey = `${fileName}_page_1`;
                const cachedImage = await getPDFImage(pageKey);
                if (cachedImage) {
                    continue; // Skip if already cached
                }
                const imgBlob = await fetchImageAsBlob(fileUrl);
                if (imgBlob) {
                    await storePDFImage(pageKey, imgBlob);
                }
            }
        } catch (error) {
            console.error("Error fetching help guides:", error);
        }
    };

    const handleOnClickClearSearch = () =>{        
        dispatch(handleSidebarAnimation(false))
        setIsAdvancedSearchOpen(false),
        dispatch(resetDeviceTemplateSearch()),
        dispatch(resetDeviceSearch()),
        dispatch(resetProviderSearch()),
        dispatch(resetObserverSearch()),
        dispatch(resetPatientSearch()),
        dispatch(resetOrganizationSearch()),
        dispatch(resetDeviceAlertSearch()),
        dispatch(resetAccessLogSearch()),
        dispatch(resetDeviceAlertDashboardSearch());
        dispatch(usersList.util.resetApiState())    
    }

    return (
       
        <GlobalContext.Provider value={{ editSocket,WebSocketConnection,setEditSocket,sendMessageToStartEditing,sendMessageToStopEditing,confirmationState,setConfirmationState,confirmationStateCancel,setConfirmationStateCancel,setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage, setToastWarnmessage,ToastWarnmessage,UpdateCall, setUpdateCall, isSideBar, setIsSideBar,initialRoutePath,setInitialRoutePath,isOpen, setIsOpen , isAdvancedSearchOpen,setIsAdvancedSearchOpen,handleOnClickClearSearch, fetchAndCacheHelpGuides}}>
            <AdminOrCorporateSearchProvider>
             
                <motion.div
                    initial={{ opacity: 0 }}
                    onClick={()=>handleClear()}
                    animate={{ opacity: 1 }}
                >
                    {isInitializing ? (
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                            <div>Loading...</div>
                        </div>
                    ) : (
                        <NavigationRoutes {...props} />
                    )}
                    {Toastmessage!==''&&Toastmessage!==undefined &&<Toast 
                        message={Toastmessage}
                        type="success"
                        setToastmessage={setToastmessage} />}
                    {toastErrorMessage!==''&&toastErrorMessage!==undefined &&<Toast 
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage} />}
                    {ToastWarnmessage!==''&&ToastWarnmessage!==undefined &&<Toast 
                        message={ToastWarnmessage}
                        type="warn"
                        setToastmessage={setToastWarnmessage} />}
                </motion.div>
               
            </AdminOrCorporateSearchProvider>
        </GlobalContext.Provider>
    )
}

export default App
